export default {
  'index': 'Home',
  'register': 'Registration',
  'admin': 'Admin Home',
}
